/** Calendar dates in Asia/Tokyo. "Yesterday" decides what data is confirmed, so the browser time zone must never matter. */
const JST_DAY = new Intl.DateTimeFormat('en-CA', {timeZone: 'Asia/Tokyo', year: 'numeric', month: '2-digit', day: '2-digit'})

/** "2026-10-15" for the current day in Tokyo. */
export const jstTodayIso = (now: Date = new Date()) => JST_DAY.format(now)

const parts = (iso: string) => iso.split('-').map(Number) as [number, number, number]

/** Local-midnight Date for an ISO date, for the calendar widget. */
export const isoToDate = (iso: string) => {
  const [y, m, d] = parts(iso)
  return new Date(y, m - 1, d)
}

export const dateToIso = (d: Date) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`

export const isIsoDate = (v: unknown): v is string => {
  if (typeof v !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(v)) return false
  const [y, m, d] = parts(v)
  const t = new Date(Date.UTC(y, m - 1, d))
  return t.getUTCFullYear() === y && t.getUTCMonth() === m - 1 && t.getUTCDate() === d
}

export const jstYesterdayIso = (now: Date = new Date()) => {
  const [y, m, d] = parts(jstTodayIso(now))
  return dateToIso(new Date(y, m - 1, d - 1))
}

/** Month to date through yesterday; on the 1st the month that just ended (same rule as the backend `resolve_period`). */
export const defaultRange = (now: Date = new Date()): {from: string; to: string} => {
  const to = jstYesterdayIso(now)
  return {from: `${to.slice(0, 7)}-01`, to}
}

/** A custom range that is always valid: both dates real, in order, not after yesterday. */
export const normalizeRange = (from: unknown, to: unknown, now: Date = new Date()): {from: string; to: string} => {
  const fallback = defaultRange(now)
  if (!isIsoDate(from) || !isIsoDate(to)) return fallback
  const yesterday = jstYesterdayIso(now)
  let [a, b] = from <= to ? [from, to] : [to, from]
  if (b > yesterday) b = yesterday
  if (a > b) a = b
  return {from: a, to: b}
}
